module.exports = __webpack_public_path__ + "static/img/sos_for_queue.07a207f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sos_for_queue.gif
// module id = O9Ck
// module chunks = 24